"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegalConsentOptions = exports.DEFAULT_SUBSCRIPTIONS = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var DEFAULT_SUBSCRIPTIONS = [16, 7818550, 4898827, 349169, 1281077, 121, 50894];
exports.DEFAULT_SUBSCRIPTIONS = DEFAULT_SUBSCRIPTIONS;

var getLegalConsentOptions = function getLegalConsentOptions() {
  var privacyPolicyText = _I18n.default.text('upgrades.legalConsentOptions.privacyPolicy');

  return {
    legitimateInterest: {
      value: true,
      text: privacyPolicyText,
      legalBasis: 'LEAD',
      subscriptionTypeIds: DEFAULT_SUBSCRIPTIONS
    }
  };
};

exports.getLegalConsentOptions = getLegalConsentOptions;